import { ReferenceToSubmit } from 'features/References';
import { Reference as ReferenceResponse } from 'types';
import { BaseNimbleAPI } from './baseAPI';

class ReferencesAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/references' };
  }

  async createReferenceContact(reference: ReferenceToSubmit): Promise<ReferenceResponse> {
    const response = await this.post('/', reference);
    return response.data;
  }

  async getReferences(candidateId: number): Promise<ReferenceResponse> {
    const url = `/?candidate_id=${candidateId}`;
    const response = await this.get(url, candidateId);
    return response.data;
  }
}

export default new ReferencesAPI();
